import React, { useState } from 'react';

import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import { Container } from './styles';

export default function Toolbar({ data, onChangeToolbar }) {
  const [inputs, setInputs] = useState({});

  async function handleChangeInput(name, value) {
    const defInputs = inputs;

    defInputs[name] = value;

    await setInputs(defInputs);
    await onChangeToolbar(defInputs);
  }

  function handleRenderInput(input) {
    const { type, name, options, label } = input;

    switch (type) {
      case 'select':
        return (
          <Autocomplete
            options={options}
            getOptionLabel={(option) => option[label]}
            onChange={(e, value) => handleChangeInput(name, value)}
            style={{ width: 300 }}
            size="small"
            renderInput={(param) => (
              <TextField
                {...param}
                label={t('s.operacao.abastecimento.nomeposto')}
                size="small"
                variant="outlined"
              />
            )}
          />
        );
      default:
        return '';
    }
  }

  return <Container>{data.map((input) => handleRenderInput(input))}</Container>;
}

Toolbar.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  onChangeToolbar: PropTypes.func.isRequired,
};
